import { ResolutionDetailPage } from '@/components/governance/resolution-detail-page'

export function OperationsResolutionDetail() {
  return <ResolutionDetailPage basePath="/operations/polls" />
}
